import {
  CampoSemantico,
  CampoSemanticoProcedimento,
} from '@framework/api-client';
import { useMemo } from 'react';

export interface PreviewSemanticTagGroup {
  id: string;
  tag?: string | null;
  images: CampoSemanticoProcedimento[];
}

/**
 * Custom hook per raggruppare le immagini per tag semantici
 */
export function usePreviewSemanticTagGroups(
  imageSemanticFields: CampoSemanticoProcedimento[] | CampoSemantico[],
): PreviewSemanticTagGroup[] {
  const groupedImages = useMemo(
    () =>
      imageSemanticFields.reduce((acc, field) => {
        const tag = field.tagSemantico?.id ?? '';
        if (!acc[tag]) {
          acc[tag] = [];
        }
        acc[tag].push(field);
        return acc;
      }, {} as Record<string, CampoSemanticoProcedimento[]>),
    [imageSemanticFields],
  );

  return Object.entries(groupedImages).map(([id, images]) => ({
    id,
    tag: images[0].tagSemantico!.titolo,
    images,
  }));
}
